import * as React from "react";
const SvgZappedIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.2778 2L3.5 11.6H10.5L9.72222 18L17.5 8.4H10.5L11.2778 2Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgZappedIcon;
